import React from 'react';
import { Calculator, Ruler, Scale, Truck, BarChart3, Settings } from 'lucide-react';

export const Features: React.FC = () => {
  const features = [
    {
      icon: <Calculator className="h-8 w-8 text-blue-600" />,
      title: "Precise Calculations",
      description: "Get accurate asphalt tonnage estimates with our professional-grade calculator"
    },
    {
      icon: <Ruler className="h-8 w-8 text-blue-600" />,
      title: "Multiple Units",
      description: "Work with standard measurements in feet and inches for easy project planning"
    },
    {
      icon: <Scale className="h-8 w-8 text-blue-600" />,
      title: "Industry Standards",
      description: "Based on standard 110 LB/(SY*INCH) compacted asphalt unit weight"
    },
    {
      icon: <Truck className="h-8 w-8 text-blue-600" />,
      title: "Load Planning",
      description: "Calculate truckload requirements for efficient material transportation"
    },
    {
      icon: <BarChart3 className="h-8 w-8 text-blue-600" />,
      title: "Detailed Results",
      description: "View comprehensive results including pounds, cubic yards, and truckloads"
    },
    {
      icon: <Settings className="h-8 w-8 text-blue-600" />,
      title: "Professional Tools",
      description: "Designed for construction professionals and contractors"
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-xl p-8">
      <h2 className="text-3xl font-bold text-slate-800 mb-8 text-center">
        Professional Asphalt Calculation Tools
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div 
            key={index}
            className="p-6 rounded-lg border border-slate-200 hover:border-blue-500 transition-colors duration-300"
          >
            <div className="mb-4">{feature.icon}</div>
            <h3 className="text-xl font-semibold text-slate-800 mb-2">
              {feature.title}
            </h3>
            <p className="text-slate-600">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};